import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { LoginRequest, LoginResponse } from '../types/api.types';

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>(API_ENDPOINTS.LOGIN, data);
    return response.data;
  },
};

